import { kSteps, maxTerms, onChange, selectSource, setK, state, summary } from "./signal.js";

const PERCENT = new Intl.NumberFormat("fr-FR", { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 });

/**
 * @function initControls Binds the epicycle sliders and the K / kept energy read-outs of the page to the shared state.
 * Elements with a data-source attribute follow that signal, the others follow the analysed one.
 */
export function initControls() {
  for (const slider of document.querySelectorAll(".fx-k-slider")) {
    slider.addEventListener("input", () => {
      const source = slider.dataset.source || state.active;
      const signal = state.sources[source];
      if (signal === null) {
        return;
      }
      //Moving the slider of a canvas explains that canvas in the mathematical process.
      selectSource(source);
      setK(kSteps(maxTerms(signal))[Number(slider.value)]);
    });
  }
  onChange(update);
  update();
}

function update() {
  for (const slider of document.querySelectorAll(".fx-k-slider")) {
    const signal = state.sources[slider.dataset.source || state.active];
    slider.disabled = signal === null;
    if (signal === null) {
      continue;
    }
    const steps = kSteps(maxTerms(signal));
    slider.max = steps.length - 1;
    slider.value = steps.findIndex((K) => K >= state.K);
    slider.setAttribute("aria-valuetext", kText(signal));
  }
  for (const el of document.querySelectorAll(".fx-k-value")) {
    const signal = state.sources[el.dataset.source || state.active];
    el.textContent = signal === null ? "–" : kText(signal);
  }
  for (const el of document.querySelectorAll(".fx-power-value")) {
    const signal = state.sources[el.dataset.source || state.active];
    el.textContent = signal === null ? "–" : PERCENT.format(summary(signal, state.K).power);
  }
}

function kText(signal) {
  const { K, max } = summary(signal, state.K);
  return K === max ? `${max} (tous)` : `${K} sur ${max}`;
}
